import React, { useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import CalculatorForm from '../components/calculator/CalculatorForm'; // CalculatorFormをインポート
import ResultDisplay from '../components/calculator/ResultDisplay';// ResultDisplayをインポート

const CalculatorPage: React.FC = () => {
    // 計算結果
    const [result, setResult] = useState<number | string | null>(null);

    // 計算結果をresultに保存
    const handleCalculate = (calculatedResult: number | string) => {
        setResult(calculatedResult);
    };

    return (
        <Container className="mt-5">
            <Row className="justify-content-center">
                <Col md={6}>
                    <Card>
                        <Card.Header>四則演算</Card.Header>
                        <Card.Body>
                            <CalculatorForm onCalculate={handleCalculate} />
                            <ResultDisplay result={result} />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default CalculatorPage;
